// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"a0a8613d","726":"42fb5bf7"}[chunkId] + ".chunk.js");